export function getdata() {
	var obj = {
		headData: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "序号",
				prop: "Serial",
				width: 130,
				custom: true
			},
			{
				title: "明细内容",
				prop: "Details",
				width: 130,
				custom: true
			},
			{
				title: "账载金额",
				children: [{
					title: "1",
					prop: "AmountA",
					width: 130,
					custom: true,
				}]
			},
			{
				title: "实际发生额",
				children: [{
					title: "2",
					prop: "ActualAmount",
					width: 130,
					custom: true,
				}]
			}, {

				title: "税收规定扣除率",
				children: [{
					title: "3",
					prop: "TaxDeductionR",
					width: 130,
					custom: true,
				}],
			}, {
				title: "以前年度累计结转扣除额",
				children: [{
					title: "4",
					prop: "AccumulatedCDPY",
					width: 130,
					custom: true,
				}],
			}, {
				title: "税收金额",
				children: [{
					title: "5",
					prop: "TaxAmount",
					width: 130,
					custom: true,
				}],
			}, {
				title: "纳税调整金额",
				children: [{
					title: "6",
					prop: "TaxAdjustmentA",
					width: 130,
					custom: true,
				}],
			}, {
				title: "累计结转以后年度扣除额",
				children: [{
					title: "7",
					prop: "AccumulatedADAC",
					width: 130,
					custom: true,
				}],
			},
		],
		tableData: [{
			Serial: '',
			Details:'',
			AmountA:'',
			ActualAmount:'',
			TaxDeductionR:'',
			AccumulatedCDPY:'',
			TaxAmount:'',
			TaxAdjustmentA:'',
			AccumulatedADAC:'',
		}, {
			Serial: '',
			Details:'',
			AmountA:'',
			ActualAmount:'',
			TaxDeductionR:'',
			AccumulatedCDPY:'',
			TaxAmount:'',
			TaxAdjustmentA:'',
			AccumulatedADAC:'',
		}]
	}
	return obj
}
